import { GOAL_FEED_PAGE } from '@townsquare/config/routes';
import { createGlobalRoute } from '@townsquare/router/create-route';

export const goalsAppUpdateViewRoute = createGlobalRoute({
  exact: true,
  name: GOAL_FEED_PAGE,
  path: '/goals/updates',
  capabilities: ['goals_app:access'],
  layout: 'home',
  subproduct: 'townsquare-goals',
  enableRestrictedFallback: true,
});
